import {
  ActionStatus, IAction, withAsyncStatus,
} from "@webiz/redux-common";
import {
  getNextPaymentsCount,
  getPaymentsTransaction,
  getPaymentsTotal,
  getPaymentsDate,
  resetPaymentsStateAction
} from "./PaymentsActions";

export interface PaymentsData {
  id: number;
  name: string;
}

const initialAsyncState = {
  status: ActionStatus.INITIAL,
  nextPayout: [],
  paymentsData: [],
  paymentsTotal: {},
  paymentsDate: {},
  page: 1,
  lastPage: null,
};

const initialState = {
  ...initialAsyncState,
};

export function PaymentsReducers(state = initialState, action: IAction) {
  switch (action.type) {
    case getNextPaymentsCount.REQUEST:
    case getNextPaymentsCount.SUCCESS:
    case getNextPaymentsCount.FAIL:
      return {
        ...state,
        ...withAsyncStatus(
          state, action, getNextPaymentsCount,
        ),
      };
      case getPaymentsTransaction.REQUEST:
      case getPaymentsTransaction.SUCCESS:
      case getPaymentsTransaction.FAIL:
        return {
          ...state,
          ...(action.payload?.data && {
            paymentsData: action.payload.data.meta.current_page === 1 ? action.payload.paymentsData : [ ...state.paymentsData, ...action.payload.paymentsData ],
            page: action.payload.data.meta.current_page,
            lastPage: action.payload.data.meta.last_page,
          }),
        };
      case getPaymentsTotal.REQUEST:
      case getPaymentsTotal.SUCCESS:
      case getPaymentsTotal.FAIL:
        return {
          ...state,
          ...(action.payload?.paymentsTotal && {
            paymentsTotal: action.payload.paymentsTotal.find((obj: any) => obj.currency === 'ILS'),
          }),
        };
      case getPaymentsDate.REQUEST:
      case getPaymentsDate.SUCCESS:
      case getPaymentsDate.FAIL:
        return {
          ...state,
          ...(action.payload && {
            paymentsDate: {
              start: action.payload.startDate,
              end: action.payload.endDate
            },
          }),
        };
      case resetPaymentsStateAction.REQUEST:
      case resetPaymentsStateAction.SUCCESS:
      case resetPaymentsStateAction.FAIL:
        return {...initialState, ...state.nextPayout};
    default:
      return state;
  }
}
